import { styled } from '@mui/material';

export const AddPatientToProductDialogWrapper = styled('div')(({ theme }) => ({
    textAlign: 'center',

    '> p': {
        marginBottom: theme.spacing(4),
    },
}));
